const ADD_BATCH_ASSIGNMENTS = `mutation AddAssignments($entityIdList: [ID!]!, $entityType: Entity!, $assignmentType: String, $manifest: [AssignmentManifestInput], $assignor: ID, $dateFrom: String, $dateTo: String, $periodId: ID, $schoolYear: Int, $parentId: ID, $tags: [String]) {
  batchAddAssignment(input: {entityIdList: $entityIdList, entityType: $entityType, assignmentType: $assignmentType, manifest: $manifest, assignor: $assignor, dateFrom: $dateFrom, dateTo: $dateTo, periodId: $periodId, schoolYear: $schoolYear, parentId: $parentId, tags: $tags}) {
    assignmentId
    assignmentType
    entityId
    entityType
    assignor
    createdAt
    status
    periodId
    schoolYear
    parentId
  }
}`;

export default ADD_BATCH_ASSIGNMENTS;
